export default __webpack_public_path__ + "static/Vidrios_Aluminios_6-5d0ad451f8df15bc0b322b6232b648f0.png";